import { sendUtagEvent } from '../../core/analytics/utag_events'

export function initializeUtagEvents(blockSelector) {
  if (!blockSelector) return

  const utagClearHotelsFilters = document.querySelectorAll(`${blockSelector} .utag-clear-hotels-filters`)
  const isFhiPage = document.querySelector('html').dataset.fhiTest !== undefined
  const fhiPageType = document.querySelector('html').dataset.fhiTest

  utagClearHotelsFilters.forEach(button => {
    button.addEventListener('click', () => {
      sendUtagEvent({
        data: {
          event_name: 'filters',
          event_cat: 'filters destinations',
          event_act: 'clear filters',
          event_lbl: '',
          event_purpose: 'inspiration',
          event_structure: 'body',
        },
      })
    })
  })

  document.querySelectorAll(`${blockSelector} .utag-info-photos`).forEach(element => {
    element.addEventListener('click', () => {
      const data = {
        event_name: 'hotel_multimedia',
        event_cat: 'hotel information',
        event_act: 'see photos and videos',
        event_lbl: 'photos',
        event_purpose: 'inspiration',
        event_structure: 'popup',
      }

      if (!isFhiPage) {
        sendUtagEvent({ data: { ...data } })
      } else {
        sendUtagEvent({ data: { ...data, page_variation: fhiPageType } })
      }
    })
  })
}
